import { alertTranslations } from './alert';
import { confirmationTranslations } from './confirmation';
import { inputTranslations } from './input';
import { filterTranslations } from './filter';
import { tableTranslations } from './table';
import { fileUploaderTranslations } from './file-uploader';
import { formDirtyModalTranslations } from './form-dirty-modal';
import { elementsGroupTranslations } from './elements-group';
import { selectTranslations } from './select';
import { taskWarningModalTranslations } from './task-warning-modal';
export const i18n = [
    alertTranslations,
    confirmationTranslations,
    inputTranslations,
    filterTranslations,
    tableTranslations,
    fileUploaderTranslations,
    formDirtyModalTranslations,
    elementsGroupTranslations,
    selectTranslations,
    taskWarningModalTranslations,
];
